import {
  OrderBuilderActions,
  RESET_BUILDER,
} from '@ordersnproducts/modules/order-builder/actions/order-builder.actions';
import {
  NextWorkingDayActionActions,
  NextWorkingDayActionTypes,
} from '@ordersnproducts/modules/order-builder/shared/modules/common-specification/actions/next-working-day.actions';

export interface NextWorkingDayState {
  loading: boolean;
  nextWorkingDay: Date;
  blackout?: {
    startTime?: string;
    endTime?: string;
    startDay?: string;
    endDay?: string;
  };
}

export const initialState: NextWorkingDayState = {
  loading: false,
  nextWorkingDay: null,
};

export function reducer(
  state = initialState,
  action: NextWorkingDayActionActions | OrderBuilderActions,
): NextWorkingDayState {
  switch (action.type) {
    case NextWorkingDayActionTypes.LOAD: {
      return {
        ...state,
        loading: true,
      } as NextWorkingDayState;
    }
    case NextWorkingDayActionTypes.LOAD_COMPLETE: {
      return {
        ...state,
        loading: false,
        nextWorkingDay: action.payload.date,
        blackout: action.payload.blackout,
      } as NextWorkingDayState;
    }
    case RESET_BUILDER: {
      return {
        ...state,
        loading: false,
        nextWorkingDay: null,
      } as NextWorkingDayState;
    }
    default: {
      return state;
    }
  }
}
